var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Stepper"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-stepper', {
          attrs: {
            "items": _vm.commonSteps
          },
          model: {
            value: _vm.basicUsageActiveStepId,
            callback: function callback($$v) {
              _vm.basicUsageActiveStepId = $$v;
            },
            expression: "basicUsageActiveStepId"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Disabled and filled states"
    }
  }, [_c('a-stepper', {
    attrs: {
      "items": _vm.extendedSteps
    },
    model: {
      value: _vm.disabledAndFilledStatesActiveStepId,
      callback: function callback($$v) {
        _vm.disabledAndFilledStatesActiveStepId = $$v;
      },
      expression: "disabledAndFilledStatesActiveStepId"
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Non linear option"
    }
  }, [_c('a-stepper', {
    attrs: {
      "items": _vm.commonSteps,
      "non-linear": ""
    },
    model: {
      value: _vm.nonLinearActiveStepId,
      callback: function callback($$v) {
        _vm.nonLinearActiveStepId = $$v;
      },
      expression: "nonLinearActiveStepId"
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Vertical style"
    }
  }, [_c('a-stepper', {
    attrs: {
      "items": _vm.commonSteps,
      "vertical": ""
    },
    model: {
      value: _vm.verticalStyleActiveStepId,
      callback: function callback($$v) {
        _vm.verticalStyleActiveStepId = $$v;
      },
      expression: "verticalStyleActiveStepId"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }